/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { IconButton } from "@mui/material";
import profilePic from "../assets/me.jpeg";
import databaseImage from "../assets/database.png";
import frontendImage from "../assets/frontend.png";
import backendImage from "../assets/backend.png";
import versionControlImage from "../assets/version-control.png";
import stackImage from "../assets/stack.png";
import "../styles/Home.css";

const Home = () => {
  const linkedinUrl = "https://www.linkedin.com/in/andres-tanesini/";
  const githubUrl = "https://github.com/tane994";
  const emailAddress = "andres.tanesini94@gmail.com";
  const mailtoLink = `mailto:${emailAddress}`;

  const handleEmailClick = () => {
    const mailtoLink = `mailto:${emailAddress}`;
    window.open(mailtoLink);
  };

  return (
    <div className="Home">
      <div className="about">
        <img src={profilePic} alt="pic-of-me" className="profile-img" />
        <h2>
          Hi, I'm <span className="name">Andrés</span>
        </h2>
        <div className="prompt">
          <p>
            Driven by a passion for programming and enriched by Italian-Colombian heritage, I am committed to continual growth
            through fitness, reading, and learning.
          </p>
          <div className="social-media">
            <IconButton
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </IconButton>
            <IconButton onClick={handleEmailClick} aria-label="Email">
              <AlternateEmailIcon href={mailtoLink} aria-label="Email" />
            </IconButton>
            <IconButton
              href={githubUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <GitHubIcon />
            </IconButton>
          </div>
        </div>
      </div>
      <div className="tech-stack-container">
        <h2 className="stack-title">
          My Tech Stack
          <img
            src={stackImage}
            alt="stack-image"
            className="stack-icon"
          />
        </h2>
        <div className="tech-stack">
          <div className="stack-card">
            <h2>Frontend</h2>
            <img
              src={frontendImage}
              alt="frontend-image"
              className="stack-image"
            />
            <div className="wrapper">
              <ul>
                <li>HTML & CSS</li>
                <li>JavaScript</li>
                <li>React</li>
                <li>Redux</li>
              </ul>
            </div>
          </div>
          <div className="stack-card">
            <h2>Backend</h2>
            <img
              src={backendImage}
              alt="backend-image"
              className="stack-image"
            />
            <div className="wrapper">
              <ul>
                <li>Node.js</li>
                <li>Express.js</li>
                <li>Java</li>
                <li>Python</li>
              </ul>
            </div>
          </div>
          <div className="stack-card">
            <h2>Database</h2>
            <img
              src={databaseImage}
              alt="database-image"
              className="stack-image"
            />
            <div className="wrapper">
              <ul>
                <li>PostgreSQL</li>
                <li>MySQL</li>
              </ul>
            </div>
          </div>
          <div className="stack-card">
            <h2>Other Development Tools</h2>
            <img
              src={versionControlImage}
              alt="version-control-image"
              className="stack-image"
            />
            <div className="wrapper">
              <ul>
                <li>Git</li>
                <li>GitHub</li>
                <li>Gradle & Maven</li>
                <li>Jest & JUnit</li>
                <li>Cypress</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
